<!-- <ion-content color="dark"> -->
<div class="one3d-loader-wrapper">
  <div class="one3d-loader-wrap">
    <!-- <div class="one3d-loader-logo">
        <img src="assets/img/icons/logo.svg" />
      </div> 
      <div class="one3d-loader-line">
        <img src="assets/img/icons/logo-line.svg" />
      </div> -->
    <div class="one3d-loader-bottom">
      <div class="one3d-loader-left one3d-loader-blink">
        <img src="assets/img/icons/logo-headlight.svg" />
      </div>
      <div class="one3d-loader-center">
        <div class="one3d-loader-bar-black" *ngFor="let item of progressBars">
          <div class="one3d-loader-bar-yellow" [id]="item"></div>
        </div>
      </div>
      <div class="one3d-loader-right one3d-loader-blink">
        <img src="assets/img/icons/logo-headlight.svg" />
      </div>
    </div>
    <div class="one3d-loader-percentage">
      {{ loaderPercent ? loaderPercent : 0 }}%
    </div>
    <div class="one3d-loader-text">
      {{'LOADER_MODAL.LOADING_JEEP' | translate}}
      {{ globalService.model?.model_name | titlecase }} {{'LOADER_MODAL.EXPERIENCE' | translate}} ...
    </div>    
  </div>
  
</div>
<!-- </ion-content> -->
